import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer';
import HeaderLine from '../../components/font/headerline';
import Header from '../../components/font/header1';
import Header2 from '../../components/font/header2';
import H4 from '../../components/font/H4';
import cities from '../../data/cities';
import regions from '../../data/cityRegions';

const citiesByRegion = Object.entries(cities).reduce((acc, [slug, city]) => {
    acc[city.region] = acc[city.region] || [];
    acc[city.region].push({ slug, ...city });
    return acc;
}, {});

Object.values(citiesByRegion).forEach((list) => list.sort((a, b) => a.cityName.localeCompare(b.cityName)));

function LocationsIndexPage() {
    return (
        <div>
            <SEO
                title="Locations We Serve | HomeButler"
                description="Find HomeButler's Home Operating System in your city. Browse home maintenance tracking, AI task triage, and pro matching by location across the US."
                path="/locations"
            />
            <Navbar links={true} />
            <div className='flex flex-row pt-8'>
                <HeaderLine />
                <div className='flex flex-col place-items-center flex-1 lg:flex-none w-full lg:w-auto px-4'>
                    <Header>Locations We Serve</Header>
                </div>
                <HeaderLine />
            </div>
            <Header2>Find HomeButler in your city</Header2>
            <div className='max-w-5xl mx-auto px-6 lg:px-0 pb-20'>
                {Object.keys(regions).map((regionKey) => {
                    const regionCities = citiesByRegion[regionKey];
                    if (!regionCities || regionCities.length === 0) return null;
                    return (
                        <div key={regionKey} className='pt-12'>
                            <H4>{regions[regionKey].label.replace(/^the /i, '')}</H4>
                            <div className='flex flex-row flex-wrap justify-center gap-x-6 gap-y-3 pt-4'>
                                {regionCities.map((city) => (
                                    <Link
                                        key={city.slug}
                                        to={`/locations/${city.slug}`}
                                        className='text-darkblue hover:text-blue underline underline-offset-4'
                                    >
                                        {city.cityName}, {city.state}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
            <Footer links={true} />
        </div>
    );
}

export default LocationsIndexPage;
